declare interface Window {
  PortalI18n: PortalI18n
}

declare interface PortalI18n {
  translateLocale(locale:string, key:string, vars?:object): string
  currentLocale:string
}

declare var window: Window;

export function translate( key:string, vars?:object, noPrefix:boolean = false) {
  var locale:string = window.PortalI18n.currentLocale;
  if (noPrefix) {
    return window.PortalI18n.translateLocale(locale, key, vars);
  } else {
    return window.PortalI18n.translateLocale(locale, 'streamApp.' + key, vars);
  }
}